import { ProductCategory, TargetGroup } from '@/helper/enums';
import type { GlobalProjectSettingsStoryblok, PartialStepSettingStoryblok } from '@/types/component-types-sb';

export function getCalculatorDefaultConsumptionString(
  settings: GlobalProjectSettingsStoryblok | null | undefined,
  productCategory: ProductCategory,
  heatflow: boolean | undefined,
  targetGroup: TargetGroup
): string {
  if (targetGroup === TargetGroup.PK) {
    if (productCategory === ProductCategory.Electricity) {
      return heatflow
        ? (settings?.calculator_default_consumption_pk_ht ?? '')
        : (settings?.calculator_default_consumption_pk_strom ?? '');
    }
    return settings?.calculator_default_consumption_pk_gas ?? '';
  }

  if (productCategory === ProductCategory.Electricity) {
    return settings?.calculator_default_consumption_gk_strom ?? '';
  }
  return settings?.calculator_default_consumption_gk_gas ?? '';
}

export function getCalculatorDefaultConsumptionNtString(
  settings: GlobalProjectSettingsStoryblok | null | undefined,
  heatflow: boolean | undefined
): string {
  return heatflow ? (settings?.calculator_default_consumption_pk_nt ?? '') : '';
}

/** PK + icon row: step whose `value` matches default consumption from settings. */
export function resolveCalculatorDefaultSelectedStep(
  settings: GlobalProjectSettingsStoryblok | null | undefined,
  productCategory: ProductCategory,
  heatflow: boolean | undefined,
  targetGroup: TargetGroup
): PartialStepSettingStoryblok | undefined {
  if (!settings || heatflow || targetGroup !== TargetGroup.PK) return undefined;

  const steps =
    productCategory === ProductCategory.Electricity
      ? settings.consumption_steps_electricity
      : settings.consumption_steps_gas;
  if (!steps?.length) return undefined;

  const consumptionStr = getCalculatorDefaultConsumptionString(settings, productCategory, heatflow, targetGroup).trim();
  if (!consumptionStr) return undefined;

  return steps.find((s) => String(s.value).trim() === consumptionStr);
}
